import React from 'react'
import Header from './Header/Header'
import Home from './Home/Home'
import Skills from './Skills/Skills'
import Services from './Services/Services'
import Projects from './Projects/Projects'
import Testimonial from './Testimonial/Testimonial'
import Contact from './Contact/Contact'
import Footer from './Footer/Footer'
import ScrollUp from './ScrollUp/ScrollUp'
import ScrollAn from './scrollreveal/ScrollAn'

const Arabic = () => {
    document.documentElement.lang="ar"
    document.dir = 'rtl'
    return (
        <>
        <Header/>
        <main className="main">
            <Home/>
            <Skills/>
            <Services/>
            <Projects/>
            <Testimonial/>
            <Contact/>
            <ScrollAn />
            <ScrollUp/>
        </main>
        <Footer/>
        </>
    )
}

export default Arabic